import { API } from "../../api";

const BASE_URL = "/cooperatives/settings/roles";

const extendedRoleApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyRoles: builder.query({
      query: ({ page = 1 } = {}) => `${BASE_URL}?guard=staff&page=${page}`,
      transformResponse: (responseData) => {
        // Paginated: data.data or data
        const payload = responseData?.data;
        if (Array.isArray(payload)) return payload;
        if (Array.isArray(payload?.data)) return payload.data;
        return [];
      },
      providesTags: ["CompanyRoles"],
    }),
    getCompanyRole: builder.query({
      query: (roleId) => `${BASE_URL}/${roleId}/view?guard=staff`,
      transformResponse: (responseData) => responseData?.data,
      providesTags: (_r, _e, roleId) => [{ type: "CompanyRoles", id: roleId }],
    }),
    createCompanyRole: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/add?guard=staff`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["CompanyRoles"],
    }),
    updateCompanyRole: builder.mutation({
      query: ({ roleId, ...body }) => ({
        url: `${BASE_URL}/${roleId}/edit?guard=staff`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["CompanyRoles"],
    }),
    getPlanModulesCatalog: builder.query({
      query: () => `/generals/modules?guard=staff`,
      transformResponse: (responseData) => responseData?.data ?? [],
    }),
  }),
});

export const {
  useGetCompanyRolesQuery,
  useGetCompanyRoleQuery,
  useCreateCompanyRoleMutation,
  useUpdateCompanyRoleMutation,
  useGetPlanModulesCatalogQuery,
} = extendedRoleApi;

/** @deprecated Prefer useGetCompanyRolesQuery */
export const useGetRolesQuery = useGetCompanyRolesQuery;
